 
const countries = require('node-countries') 
import ipLocation from "iplocation" 
export default{
  state: {
    //TODO list of countries and there code
    countries:countries,
    customCountries:[
      {id:1, name:'Malawi', districts: [
        { id: 1, name: 'Balaka', iso: 'BA', region:'Southern',area:{}},
        { id: 2, name: 'Blantyre', iso: 'BL', region: 'Southern', area: {} },
        { id: 3, name: 'Chikwawa', iso: 'CK', region: 'Southern', area: {} },
        { id: 4, name: 'Chiradzulu', iso: 'CR', region: 'Southern', area: {} },
        { id: 5, name: 'Chitipa', iso: 'CT', region: 'Northern', area: {} },
        { id: 6, name: 'Dedza', iso: 'DE', region: 'Central', area: {} },
        { id: 7, name: 'Dowa', iso: 'DO', region: 'Central', area: {} },
        { id: 8, name: 'Karonga', iso: 'KR', region: 'Northern', area: {} },
        { id: 9, name: 'Kasungu', iso: 'KS', region: 'Central', area: {} },
        { id: 10, name: 'Likoma', iso: 'LK', region: 'Northern', area: {} },
        { id: 11, name: 'Lilongwe', iso: 'LI', region: 'Central', area: {} },
        { id: 12, name: 'Machinga', iso: 'MH', region: 'Southern', area: {} },
        { id: 13, name: 'Mangochi', iso: 'MG', region: 'Southern', area: {} },
        { id: 14, name: 'Mchinji', iso: 'MC', region: 'Central', area: {} },
        { id: 15, name: 'Mulanje', iso: 'MU', region: 'Southern', area: {} },
        { id: 16, name: 'Mwanza', iso: 'MW', region: 'Southern', area: {} },
        { id: 17, name: 'Mzimba', iso: 'MZ', region: 'Northern', area: {} },
        { id: 18, name: 'Neno', iso: 'NE', region: 'Southern', area: {} },
        { id: 19, name: 'Nkhata Bay', iso: 'NB', region: 'Northern', area: {} },
        { id: 20, name: 'Nkhotakota', iso: 'NK', region: 'Central', area: {} },
        { id: 21, name: 'Nsanje', iso: 'NS', region: 'Southern', area: {} },
        { id: 22, name: 'Ntcheu', iso: 'NU', region: 'Central', area: {} },
        { id: 23, name: 'Ntchisi', iso: 'NI', region: 'Central', area: {} },
        { id: 24, name: 'Phalombe', iso: 'PH', region: 'Southern', area: {} },
        { id: 25, name: 'Rumphi', iso: 'RU', region: 'Northern', area: {} },
        { id: 26, name: 'Salima', iso: 'SA', region: 'Central', area: {} },
        { id: 27, name: 'Thyolo', iso: 'TH', region: 'Southern', area: {} },
        { id: 28, name: 'Zomba', iso: 'ZO', region: 'Southern', area: {} } 
      ]}
    ],
    iLocation:null,
    IPs:{
      ip1:null,
      ip2:null
    } 
  },
  //___________________-GETTERS-_________________
  getters: {

    getMyCountries(state) {
      return state.countries
    },
    getCustomCountries(state) {
       return state.customCountries
    },
    // getIpLocation(state){
    //   return ipLocation
    // },
    // getILocation(state) {
    //   return state.iLocation
    // }
  },
  //___________________-MUTATIONS-___________________
  mutations: { 

  },
  //____________________-ACTIONS-_____________________
  actions: { 
    setILocations({ commit, state }, payload) {
      let http = this._vm.$http
      http.get("https://httpbin.org/ip").then(res=>{
        let ips = res.body.origin 
        if (ips.includes(",")) {
          let ip1 = ips.split(",")[0]
          let ip2 = ips.split(",")[1]
          state.IPs.ip1 = ip1
          state.IPs.ip2 = ip2 
        } else {
          state.IPs.ip1 = ips
        }
        return state.IPs
      },err=>{
        console.log(err,".."); 
        return "0.0.0.0"
      }).then(ips=>{
        return ipLocation(ips.ip1)
      }).then(res=>{
        state.iLocation = res
        console.log(res, 'i........');
      }).catch(error => {
        console.log(error, 'e........')
      }) 
    }
  },
}

